<script>
	import { sendGTM } from '$lib/analytics'
	import { GuideBox } from '$lib/components'
	import Box from '$lib/components/Box.svelte'
	import ContentWrapper from '$lib/components/ContentWrapper.svelte'
	import Expander from '$lib/components/Expander.svelte'
	import Icon from '$lib/components/Icon.svelte'
	import ShiftContent from '$lib/components/ShiftContent.svelte'
	import Header from '$lib/components/header-2.0/Header.svelte'
	import Table from '$lib/components/table/Table.svelte'
	import Td from '$lib/components/table/Td.svelte'
	import Th from '$lib/components/table/Th.svelte'
	import Tr from '$lib/components/table/Tr.svelte'
	import { ArticleV4, BlogBanner } from '$lib/modules/blog'
	import AlternatingMedia from '$lib/modules/layout/AlternatingMedia.svelte'
	import SectionHero from '$lib/modules/layout/SectionHero.svelte'
	import AdvantageBox from '$lib/modules/products/AdvantageBox.svelte'
	import FAQ_wrap from '$lib/modules/products/FAQ_wrap.svelte'
	import InstalationStep from '$lib/modules/products/InstalationStep.svelte'
	import {
		LEAVE_CONTACT,
		WOLTADVISOR,
		PHOTOVOLTAICS,
		MEETING,
		FINANCING,
		GRANTS,
		PHOTOVOLTAICS_3050
	} from '$lib/routes'
	import { t } from '$lib/translations'
	import { Anchor, Button } from '$lib/ui-woltair/components'
	import Separator from '$lib/ui-woltair/components/Separator.svelte'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data

	let pvThirtyFifty = null

	if (PHOTOVOLTAICS_3050 != null) {
		pvThirtyFifty = PHOTOVOLTAICS_3050
	} else {
		pvThirtyFifty = '/'
	}

	export const header = {
		heading: t('web.photovoltaics.header.heading'),
		subheading: t('web.photovoltaics.header.subheading'),
		references_subtext: t('web.photovoltaics.header.referencesSubtext', { link: '' }),
		subtext: t('web.photovoltaics.header.subtext', {
			link: `/${pvThirtyFifty}`
		})
	}

	const download_ico = {
		src: '/images/icons/white/download.svg',
		alt: 'Stáhnout'
	}
</script>

<Header
	{header}
	references={data.references}
	showReferences={data.featureConfig.references.pv}
	headerAsterisk={data.featureConfig.thirtyFifty.pv}
	showSubtext={data.featureConfig.thirtyFifty.pv}
>
	<svelte:fragment slot="buttonArea">
		<div class="relative">
			{#if data.featureConfig.woltadvisor.pv}
				<div class="flex pt-8 md:-mt-2-res md:pt-16">
					<a
						class="btn btn-filled-primary text-base-res"
						href="/{PHOTOVOLTAICS}/{WOLTADVISOR}"
						data-testid="calculator">{t('web.photovoltaics.header.calculator.text')}</a
					>

					<div class="relative hidden min-h-full w-full md:block">
						<img
							src="/images/icons/arrow-handdrawn.svg"
							alt=""
							class="absolute bottom-8 right-3/4 max-h-8 w-1/5"
						/>
						<img
							src="/images/misc/head-offer-pv.webp"
							alt=""
							class="absolute -bottom-2 right-0 max-h-28 w-8/12 object-contain md:-top-12"
						/>
					</div>
				</div>
			{/if}
			{#if data.featureConfig.meeting.pv}
				<div>
					<a
						class="btn btn-outline-accent-red wrap relative z-10 mt-4 text-base-res"
						href="/{PHOTOVOLTAICS}/{LEAVE_CONTACT}"
						data-testid="meeting"
						on:click={() => sendGTM('online_meet')}
						>{t('web.forms.leaveContact.button')}
					</a>
				</div>
			{/if}
		</div>
	</svelte:fragment>
	<svelte:fragment slot="bottom">
		{#if PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_CZ'}
			<a href="/optimizery-k-fotovoltaice-zdarma"
				><img
					class="page-wrapper mt-12 hidden sm:block"
					src="/images/banners/fve-optimizery-extended-desktop.webp"
					alt="Optimizéry k fotovoltaice zdarma"
					width="1328px"
					height="180px"
				/>
				<img
					class="page-wrapper mt-12 sm:hidden"
					src="/images/banners/fve-optimizery-extended-mobile.webp"
					alt="Optimizéry k fotovoltaice zdarma"
					width="400px"
					height="190px"
					loading="lazy"
				/></a
			>
		{/if}
	</svelte:fragment>
</Header>

{#if data.featureConfig.grants.pv || data.featureConfig.financing.pv}
	<div class="header page-fullwidth z-0 bg-neutral-100 pb-12-res" />

	<section class="boxes page-wrapper relative z-10 -mt-12-res grid gap-5 lg:grid-cols-2">
		{#if data.featureConfig.grants.pv}
			<AdvantageBox
				textWidth="basis-[60%]"
				subtextWidth="max-w-[80%]"
				content={{
					header: 'web.photovoltaics.boxes.grants.heading',
					text: 'web.photovoltaics.boxes.grants.text',
					buttonText: 'web.photovoltaics.boxes.grants.buttonText',
					buttonUrl: `/${PHOTOVOLTAICS}/${GRANTS}`,
					imageUrl: '/images/illustrations/house.webp',
					imageAlt: t('web.photovoltaics.boxes.grants.img.alt')
				}}
			/>
		{/if}
		{#if data.featureConfig.financing.pv}
			<AdvantageBox
				textWidth="basis-[65%]"
				subtextWidth="max-w-[70%]"
				imageCls="scale-125 lg:-translate-x-6 lg:-translate-y-10"
				content={{
					header: 'web.photovoltaics.boxes.financing.heading',
					text: 'web.photovoltaics.boxes.financing.text',
					buttonText: 'web.photovoltaics.boxes.financing.buttonText',
					buttonUrl: `/${PHOTOVOLTAICS}/${FINANCING}`,
					imageUrl: {
						WOLTAIR_CZ: '/images/illustrations/safe.webp',
						WOLTAIR_PL: '/images/illustrations/safe-nologo.webp',
						WOLTAIR_DE: '',
						WOLTAIR_IT: ''
					}[PUBLIC_WOLTAIR_WEB_CODE],
					imageAlt: t('web.photovoltaics.boxes.financing.img.alt')
				}}
			/>
		{/if}
	</section>
{/if}
{#if data.featureConfig.fveSolutions}
	<section class="page-fullwidth mt-24-res">
		<SectionHero bgImage="/images/fotovoltaika/podavani_rukou_s_panely.webp" bgWidthLimit />
		<ContentWrapper cls="px-4">
			<div class="relative pt-10 text-center">
				<div class="text-base font-semibold text-primary-500">
					{t('web.photovoltaics.solutions.suptext')}
				</div>
				<h2
					class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal text-neutral-50"
				>
					{t('web.photovoltaics.solutions.heading')}
				</h2>
				<p class="bold mb-8 pt-4 text-base-res font-semibold text-neutral-50">
					{t('web.photovoltaics.solutions.subtext')}
				</p>
			</div>
			<Expander let:expand let:expanded>
				<Box>
					<ShiftContent>
						<Table cls="w-full mt-6" th_padding="px-4 pb-4" thcls="text-left">
							<svelte:fragment slot="thead">
								<Tr>
									<Th cls="sm:border-r" />
									<Th border_r>
										<div class="bold text-base font-semibold lg:text-1.5xl">
											{t('web.photovoltaics.solutions.row0.column1')}
										</div>
									</Th>
									<Th>
										<div class="bold text-base font-semibold lg:text-1.5xl">
											{t('web.photovoltaics.solutions.row0.column2')}
										</div>
									</Th>
								</Tr>
							</svelte:fragment>
							<svelte:fragment slot="tbody">
								<Tr>
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row1.column0')}
											src="/images/icons/gray/engine.svg"
											>{t('web.photovoltaics.solutions.row1.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row1.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row1.column2')}</Td>
								</Tr>
								<Tr>
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row2.column0')}
											src="/images/icons/gray/panels.svg"
											>{t('web.photovoltaics.solutions.row2.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row2.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row2.column2')}</Td>
								</Tr>
								<Tr cls="expander {expanded ? 'isExpanded' : 'toExpand'}">
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row3.column0')}
											src="/images/icons/gray/battery.svg"
											>{t('web.photovoltaics.solutions.row3.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row3.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row3.column2')}</Td>
								</Tr>
								<Tr cls="expander {expanded ? 'isExpanded' : 'toExpand'}">
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row4.column0')}
											src="/images/icons/gray/mallet.svg"
											>{t('web.photovoltaics.solutions.row4.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row4.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row4.column2')}</Td>
								</Tr>
								<Tr cls="expander {expanded ? 'isExpanded' : 'toExpand'}">
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row5.column0')}
											src="/images/icons/gray/money.svg"
											>{t('web.photovoltaics.solutions.row5.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row5.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row5.column2')}</Td>
								</Tr>
								<Tr cls="expander {expanded ? 'isExpanded' : 'toExpand'}">
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row6.column0')}
											src="/images/icons/gray/pricetag.svg"
											>{t('web.photovoltaics.solutions.row6.column0')}</Icon
										>
									</Td>
									<Td border_r>{t('web.photovoltaics.solutions.row6.column1')}</Td>
									<Td>{t('web.photovoltaics.solutions.row6.column2')}</Td>
								</Tr>
								<Tr>
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row7.column0')}
											src="/images/icons/gray/pricetag.svg"
											>{t('web.photovoltaics.solutions.row7.column0')}</Icon
										>
									</Td>
									<Td border_r
										><div class="bold">{t('web.photovoltaics.solutions.row7.column1')}</div></Td
									>
									<Td><div class="bold">{t('web.photovoltaics.solutions.row7.column2')}</div></Td>
								</Tr>
								<Tr>
									<Td cls="pl-0 pr-0 sm:pr-4 sm:border-r">
										<Icon
											smallHideText
											alt={t('web.photovoltaics.solutions.row8.column0')}
											src="/images/icons/gray/piggy.svg"
											>{t('web.photovoltaics.solutions.row8.column0')}</Icon
										>
									</Td>
									<Td border_r
										><div class="bold text-green-600">
											{t('web.photovoltaics.solutions.row8.column1')}
										</div></Td
									>
									<Td
										><div class="bold text-green-600">
											{t('web.photovoltaics.solutions.row8.column2')}
										</div></Td
									>
								</Tr>
							</svelte:fragment>
						</Table>
					</ShiftContent>
				</Box>
				<details open={expanded}>
					<div class="col-span-12 pt-12">
						<!-- <div class="{expanded ? 'isExpanded' : 'isExpanded'} pt-12 col-span-12"> -->
						<h3 class="mb-12 text-center">{t('web.photovoltaics.components.heading')}</h3>
						<AlternatingMedia>
							<svelte:fragment slot="media">
								<img
									src={PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL'
										? '/images/fotovoltaika/battery-pylontech-h2.webp'
										: '/images/fotovoltaika/Battery_HV9637.webp'}
									alt={t('web.photovoltaics.components.component1.name')}
									class="inline-block"
								/>
							</svelte:fragment>
							<Table tdcls="" td_padding="py-4" th_padding="pb-4">
								<svelte:fragment slot="thead">
									<Tr>
										<Th colspan="2" cls="text-left"
											>{t('web.photovoltaics.components.component1.name')}</Th
										>
									</Tr>
								</svelte:fragment>
								<svelte:fragment slot="tbody">
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component1.row0.column0')}
												src="/images/icons/gray/checkmark_star.svg"
												>{t('web.photovoltaics.components.component1.row0.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component1.row0.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component1.row1.column0')}
												src="/images/icons/gray/battery_fill.svg"
												>{t('web.photovoltaics.components.component1.row1.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component1.row1.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component1.row2.column0')}
												src="/images/icons/gray/people.svg"
												>{t('web.photovoltaics.components.component1.row2.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component1.row2.column1')}</Td
										>
									</Tr>
									<!-- <Tr>
                  <Td>
                    <Icon alt="Roční úspora" src="/images/icons/gray/engine.svg">Výkon</Icon>
                  </Td>
                  <Td cls="text-right">3,55 kW</Td>
                </Tr> -->
								</svelte:fragment>
							</Table>
							<Button
								iconPre={download_ico}
								tiny
								href="https://storage.googleapis.com/docnote-kotelna-bucket-dev/XDYC9DBPCY-dyness.pdf"
								cls="mt-4"
							>
								{t('web.photovoltaics.components.productList')}
							</Button>
						</AlternatingMedia>
						<AlternatingMedia alternating>
							<svelte:fragment slot="media">
								<img
									src={PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL'
										? '/images/fotovoltaika/panels-trina.webp'
										: '/images/fotovoltaika/Panely_Risen_RSM.webp'}
									alt={t('web.photovoltaics.components.component2.name')}
									class="inline-block"
								/>
							</svelte:fragment>
							<Table tdcls="" td_padding="py-4" th_padding="pb-4">
								<svelte:fragment slot="thead">
									<Tr>
										<Th colspan="2" cls="text-left"
											>{t('web.photovoltaics.components.component2.name')}</Th
										>
									</Tr>
								</svelte:fragment>
								<svelte:fragment slot="tbody">
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component2.row0.column0')}
												src="/images/icons/gray/engine.svg"
												>{t('web.photovoltaics.components.component2.row0.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component2.row0.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component2.row1.column0')}
												src="/images/icons/gray/frame.svg"
												>{t('web.photovoltaics.components.component2.row1.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component2.row1.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component2.row2.column0')}
												src="/images/icons/gray/loader.svg"
												>{t('web.photovoltaics.components.component2.row2.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component2.row2.column1')}</Td
										>
									</Tr>
								</svelte:fragment>
							</Table>
							<Button
								iconPre={download_ico}
								tiny
								href="/images/fotovoltaika/Panely_Risen_RSM.webp"
								cls="mt-4"
							>
								{t('web.photovoltaics.components.productList')}
							</Button>
						</AlternatingMedia>
						<AlternatingMedia>
							<svelte:fragment slot="media">
								<img
									src="/images/fotovoltaika/Stridac_GoodWe_10_ET.webp"
									alt={t('web.photovoltaics.components.component3.name')}
									class="inline-block"
								/>
							</svelte:fragment>
							<Table tdcls="" td_padding="py-4" th_padding="pb-4">
								<svelte:fragment slot="thead">
									<Tr>
										<Th colspan="2" cls="text-left"
											>{t('web.photovoltaics.components.component3.name')}</Th
										>
									</Tr>
								</svelte:fragment>
								<svelte:fragment slot="tbody">
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component3.row0.column0')}
												src="/images/icons/gray/checkmark_small.svg"
												>{t('web.photovoltaics.components.component3.row0.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component3.row0.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component3.row1.column0')}
												src="/images/icons/gray/engine.svg"
												>{t('web.photovoltaics.components.component3.row1.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component3.row1.column1')}</Td
										>
									</Tr>
									<Tr>
										<Td>
											<Icon
												alt={t('web.photovoltaics.components.component3.row2.column0')}
												src="/images/icons/gray/engine.svg"
												>{t('web.photovoltaics.components.component3.row2.column0')}</Icon
											>
										</Td>
										<Td cls="text-right"
											>{t('web.photovoltaics.components.component3.row2.column1')}</Td
										>
									</Tr>
								</svelte:fragment>
							</Table>
							<Button
								iconPre={download_ico}
								tiny
								href="/documents/0X2BR1C6MK-goodwe-et-datasheet-cz.pdf"
								cls="mt-4"
							>
								{t('web.photovoltaics.components.productList')}
							</Button>
						</AlternatingMedia>
					</div>
					<summary
						class="mt-10 list-none text-center text-xs
        {expanded ? 'toExpand' : 'isExpanded'}
         "
					>
						<Button tiny tertiary on:click={expand} on:keypress={expand}
							>{t('web.photovoltaics.solutions.showMore.button')}</Button
						>
						<p class="text-xs text-neutral-500">
							{t('web.photovoltaics.solutions.showMore.subtext')}
						</p>
					</summary>
				</details>
			</Expander>
		</ContentWrapper>
	</section>
{/if}
{#if data.featureConfig.fveWarranties}
	<section class="page-fullWidth mt-16-res bg-[url(/images/logos/woltair_bg_gray.svg)] bg-center">
		<ContentWrapper cls="px-6 pt-6 pb-16">
			<div class="relative pt-10 text-center">
				<div class="text-base font-semibold text-primary-500">
					{t('web.photovoltaics.warranties.suptext')}
				</div>
				<h2
					class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal text-neutral-800"
				>
					{t('web.photovoltaics.warranties.heading')}
				</h2>
				<p class="bold mb-8 pt-4 text-base-res font-semibold text-neutral-800">
					{t('web.photovoltaics.warranties.subtext')}
				</p>
			</div>

			<ShiftContent>
				<div class="grid grid-cols-2 gap-6 text-center sm:grid-cols-3 md:text-left lg:grid-cols-5">
					<div class="text-center">
						<Icon
							src="/images/icons/red/engine.svg"
							width="w-7"
							height="h-5"
							margin=""
							alt={t('web.photovoltaics.warranties.block1.name')}
						/>
						<div class="mt-4 whitespace-nowrap">
							{t('web.photovoltaics.warranties.block1.name')}
						</div>
						<div class="text-2.5xl font-semibold">
							{t('web.photovoltaics.warranties.block1.value')}
						</div>
					</div>
					<div class="text-center">
						<Icon
							src="/images/icons/red/battery.svg"
							width="w-7"
							height="h-5"
							margin=""
							alt={t('web.photovoltaics.warranties.block2.name')}
						/>
						<div class="mt-4 whitespace-nowrap">
							{t('web.photovoltaics.warranties.block2.name')}
						</div>
						<div class="text-2.5xl font-semibold">
							{t('web.photovoltaics.warranties.block2.value')}
						</div>
					</div>
					<div class="text-center">
						<Icon
							src="/images/icons/red/screen.svg"
							width="w-7"
							height="h-4"
							margin=""
							alt={t('web.photovoltaics.warranties.block3.name')}
						/>
						<div class="mt-4 whitespace-nowrap">
							{t('web.photovoltaics.warranties.block3.name')}
						</div>
						<div class="text-2.5xl font-semibold">
							{t('web.photovoltaics.warranties.block3.value')}
						</div>
					</div>
					<div class="text-center">
						<Icon
							src="/images/icons/red/cog.svg"
							width="w-7"
							height="h-5"
							margin=""
							alt={t('web.photovoltaics.warranties.block4.name')}
						/>
						<div class="mt-4 whitespace-nowrap">
							{t('web.photovoltaics.warranties.block4.name')}
						</div>
						<div class="text-2.5xl font-semibold">
							{t('web.photovoltaics.warranties.block4.value')}
						</div>
					</div>
					<div class="text-center">
						<Icon
							src="/images/icons/red/briefcase.svg"
							width="w-7"
							height="h-5"
							margin=""
							alt={t('web.photovoltaics.warranties.block5.name')}
						/>
						<div class="mt-4 whitespace-nowrap">
							{t('web.photovoltaics.warranties.block5.name')}
						</div>
						<div class="text-2.5xl font-semibold">
							{t('web.photovoltaics.warranties.block5.value')}
						</div>
					</div>
				</div>
			</ShiftContent>
		</ContentWrapper>
	</section>
{/if}

{#if data.featureConfig.guide.pv}
	<section class="page-wrapper mt-24-res">
		<Separator />
		<h2
			class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
		>
			{t('web.photovoltaics.guide.title')}
		</h2>

		<div
			class="inset-0 mx-auto mt-12 grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
		>
			<GuideBox
				title={t('web.photovoltaics.guide.box1.title')}
				text={t('web.photovoltaics.guide.box1.text')}
				link={t('web.photovoltaics.guide.box1.link')}
			/>
			<GuideBox
				title={t('web.photovoltaics.guide.box2.title')}
				text={t('web.photovoltaics.guide.box2.text')}
				link={t('web.photovoltaics.guide.box2.link')}
			/>
			<GuideBox
				title={t('web.photovoltaics.guide.box3.title')}
				text={t('web.photovoltaics.guide.box3.text')}
				link={t('web.photovoltaics.guide.box3.link')}
			/>
		</div>
	</section>
{/if}

{#if data.featureConfig.fveInstalationSteps}
	<section class="page-wrapper mt-24-res">
		<Separator />
		<h2
			class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
		>
			{t('web.photovoltaics.realization.heading')}
		</h2>
		<section class="mt-20-res">
			<Expander let:expand let:expanded>
				<div class="grid grid-cols-7 md:grid-cols-10 md:gap-20">
					<div class="col-span-7 md:col-span-6">
						<InstalationStep>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step1.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">1</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step1.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">
									{t('web.photovoltaics.realization.step1.text')}
								</p>
								{#if data.featureConfig.meeting.pv}
									<Button tiny href="/{PHOTOVOLTAICS}/{MEETING}" cls="mt-6 !text-xs sm:!text-sm"
										>{t('web.photovoltaics.realization.orderButtonText')}</Button
									>
								{/if}
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step2.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">2</svelte:fragment>
							<svelte:fragment slot="extrasteps">
								<div
									class="{expanded
										? 'toExpand'
										: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full bg-neutral-800 text-center text-xs text-white"
								>
									3
								</div>
								<div
									class="{expanded
										? 'toExpand'
										: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full bg-neutral-700 text-center text-xs text-white"
								>
									4
								</div>
								<div
									class="{expanded
										? 'toExpand'
										: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full bg-neutral-600 text-center text-xs text-white"
								>
									5
								</div>
								<div
									class="{expanded
										? 'toExpand'
										: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full bg-neutral-400 text-center text-xs text-white"
								>
									6
								</div>
								<div
									class="{expanded
										? 'toExpand'
										: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full bg-neutral-200 text-center text-xs text-white"
								>
									7
								</div>
							</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step2.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">
									{t('web.photovoltaics.realization.step2.text')}
								</p>
								<Button
									on:click={expand}
									on:keypress={expand}
									tiny
									tertiary
									cls="mt-6 {expanded ? 'hidden' : ''} !text-xs sm:!text-sm"
								>
									{t('web.photovoltaics.realization.expandButtonText')}
								</Button>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step3.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">3</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step3.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step3.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step4.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">4</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step4.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step4.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step5.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">5</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step5.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step5.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step6.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">6</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step6.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step6.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step7.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">7</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step7.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step7.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step8.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">8</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step8.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step8.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step9.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">9</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step9.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step9.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step10.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">10</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step10.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step10.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step11.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">11</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step11.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step11.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step12.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">12</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step12.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step12.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step13.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">13</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step13.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step13.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step14.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">14</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step14.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step14.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep noborder cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step15.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">15</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step15.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step15.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep noborder cls={expanded ? 'isExpanded' : 'hidden'}>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step16.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">16</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step16.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step16.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep noborder>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step17.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">17</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step17.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step17.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep noborder>
							<svelte:fragment slot="timing"
								>{t('web.photovoltaics.realization.step18.timing')}</svelte:fragment
							>
							<svelte:fragment slot="num">18</svelte:fragment>
							<svelte:fragment slot="title"
								>{t('web.photovoltaics.realization.step18.title')}</svelte:fragment
							>
							<svelte:fragment slot="content">
								<p class="text-xs">{t('web.photovoltaics.realization.step18.text')}</p>
							</svelte:fragment>
						</InstalationStep>
						<InstalationStep noborder>
							<svelte:fragment slot="content">
								<Button
									on:keypress={expand}
									on:click={expand}
									tiny
									tertiary
									cls="mt-4 {expanded ? '' : '!hidden'} !text-xs sm:!text-sm"
								>
									{t('web.photovoltaics.realization.hideButtonText')}
								</Button>
							</svelte:fragment>
						</InstalationStep>
					</div>
					<div
						class="col-span-4 hidden grid-flow-row-dense content-center gap-6 md:grid lg:col-span-3 lg:pr-12"
					>
						<img src="/images/fotovoltaika/steps_1.webp" alt="" />
						<img src="/images/fotovoltaika/steps_2.webp" alt="" />
						<img
							src="/images/fotovoltaika/steps_3.webp"
							alt=""
							class={expanded ? 'isExpanded' : 'toExpand'}
						/>
						<img
							src="/images/fotovoltaika/steps_4.webp"
							alt=""
							class={expanded ? 'isExpanded' : 'toExpand'}
						/>
						<img
							src="/images/fotovoltaika/steps_5.webp"
							alt=""
							class={expanded ? 'isExpanded' : 'toExpand'}
						/>
					</div>
				</div>
			</Expander>
		</section>
	</section>
{/if}
{#if data?.orders?.length > 0 && data.featureConfig.references.pv && PUBLIC_WOLTAIR_WEB_CODE !== 'WOLTAIR_PL'}
	<section class="page-wrapper mt-24-res">
		<Separator />
		<h2
			class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
		>
			{t('web.photovoltaics.projects.heading')}
		</h2>
		<!--
		<div
			class="center inset-x-0 mx-auto mt-16-res flex flex-col items-center gap-16-res-25 pb-5 sm:max-w-5xl sm:flex-row"
		>
			
			<div class="max-w-sm basis-4/12 sm:max-w-none">
				<img
					class="aspect-[3/2] h-auto w-full rounded-md object-cover"
					src="https://lh3.googleusercontent.com/Aj4h4zClfJWKS81sbqZqfZ5py1YJ8JjP3YYaz1ngnElB9VHA3G5ONDnjNN31LxqM2m1UbjE4O6Q-bb-xL7XgqMRT9sIRO9J-3GNOx0Fj1kTbpmOhkg"
					alt={t('web.photovoltaics.projects.review.img.alt')}
				/>
				<p class="mt-4 text-sm-res">
					{t('web.photovoltaics.projects.review.device', {
						deviceType: 'Buderus MX200'
					})}
				</p>
			</div>

			<div class="max-w-sm basis-7/12 sm:max-w-none">
				<p class="mt-2 text-2.5xl-res font-light italic leading-snug">
					{t('web.photovoltaics.projects.review.text')}
				</p>
				<div class="mt-8">
					<p class="text-1.5xl-res font-semibold">{t('web.photovoltaics.projects.review.name')}</p>
					<p class="text-1.5xl-res">{t('web.photovoltaics.projects.review.region')}</p>
				</div>
			</div>
		</div>-->

		<div class="inset-0 mx-auto mt-16 flex max-w-5xl flex-col items-center gap-8 md:flex-row">
			<div class="h-fit w-full max-w-lg basis-1/2">
				<p class="text-lg font-semibold">{t('web.photovoltaics.projects.subheading')}</p>
				<div class="my-6 grid grid-cols-2">
					{#each data.orders as orderGroup}
						<a
							href="/{PHOTOVOLTAICS}/{orderGroup.slug}"
							class="leading-0 col-span-1 h-fit text-sm text-primary-500 underline"
							>{`${orderGroup.region} (${orderGroup.value})`}</a
						>
					{/each}
				</div>
				<div class="col-span-2 pt-6">
					<span class="inline-block align-middle text-sm"
						>{t('web.photovoltaics.projects.moreAbroad')}</span
					>
					<img src="/images/icons/flag/pl.svg" alt="" class="inline-block pl-2 align-middle" />
					<img src="/images/icons/flag/it.svg" alt="" class="inline-block pl-2 align-middle" />
					<img src="/images/icons/flag/de.svg" alt="" class="inline-block pl-2 align-middle" />
				</div>
			</div>

			<div class="max-w-md basis-1/2 md:max-w-none">
				<img src="/images/illustrations/map_cz.svg" alt="" />
			</div>
		</div>
	</section>
{/if}

{#if data.article && data.featureConfig.fvePageArticle}
	<section class="page-wrapper">
		<ArticleV4 article={data.article} referer={false} />
	</section>
{/if}

{#if data.faqs?.length}
	<Anchor id="faq" />
	<section class="page-wrapper mt-20-res">
		<Separator />
		<h2
			class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
		>
			{t('web.photovoltaics.faq.heading')}
		</h2>

		<div class="mt-16-res flex flex-col flex-wrap gap-x-10 pb-16 lg:flex-row">
			{#each data.faqs as faq}
				<FAQ_wrap>
					<svelte:fragment slot="question">{faq.question}</svelte:fragment>
					<svelte:fragment slot="answer">{@html faq.answer}</svelte:fragment>
				</FAQ_wrap>
			{/each}
		</div>
	</section>
{/if}

{#if data.otherArticles?.length > 0}
	<section class="page-wrapper mt-16-res !max-w-[842px]">
		<Separator />
		<h2
			class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
		>
			{t('web.photovoltaics.articles.heading')}
		</h2>

		<BlogBanner articles={data.otherArticles} hideTitle />
	</section>
{/if}
<section class="footer-people mt-28-res hidden h-[200px] md:block md:h-[400px]" />

<style>
	.footer-people {
		background-image: url('/images/persons/woltair-people_2x_crop.webp');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}
</style>
